const list = [
    // reg match
    '/payment',
    'banSidebar',
    '/print',
    'importexcel',
    '/tuan/',
    'SelectGood',
    'settle',
    'Myorder',
    'Success',
    'orderdetail',
    'home',
    '/download/',
    'useraddress',
    'mallprint',
    '/auth',
    'picklist',
    'pay'
]
export default list